import { NavigationProp, useNavigation } from '@react-navigation/core';
import { StackNavigationProp } from '@react-navigation/stack';
import { last } from 'ramda';
import { useDebugValue, useMemo } from 'react';
import type { AppModalParams } from '../../../flows/Routes';

export type AppModalNavigation = StackNavigationProp<AppModalParams>;

export const useAppModalNavigation = () => useNavigation<AppModalNavigation>();

export const useIsInScreen = (screenName: keyof AppModalParams): boolean => {
  const nav = useNavigation();
  const rootNav = useMemo(() => getRoot(nav), [nav]);
  const currRoute = last(rootNav.getState().routes);
  const res = currRoute?.name === screenName;
  useDebugValue(res);
  return res;
};

const getRoot = (nav: NavigationProp<any>): NavigationProp<any> => {
  while (true) {
    const parent = nav.getParent();
    if (parent == null) return nav;
    nav = parent;
  }
};
